export { default } from 'web-ssr/app/common/components/ContentHeader/Container';
export {
  default as HeaderProvider,
} from 'web-ssr/app/common/components/ContentHeader/HeaderProvider';
